import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=169cd50e"
import script from "./top-menu.ts?vue&type=script&lang=js&external"
export * from "./top-menu.ts?vue&type=script&lang=js&external"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=169cd50e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports